// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/static/img/spence-10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/static/img/stock-photo-rear-view-of-female-friends-practicing-vrikshasana-o.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.community-list {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.community-list .div {
  background-color: #ffffff;
  height: 4619px;
  overflow: hidden;
  position: relative;
  width: 1280px;
}

.community-list .overlap-group {
  height: 370px;
  left: -1px;
  position: absolute;
  top: 1146px;
  width: 1281px;
}

.community-list .rectangle {
  height: 369px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 634px;
}

.community-list .img {
  height: 369px;
  left: 634px;
  mix-blend-mode: multiply;
  object-fit: cover;
  position: absolute;
  top: 1px;
  width: 647px;
}

.community-list .connect-with-your {
  height: 47px;
  left: 710px;
  object-fit: cover;
  position: absolute;
  top: 145px;
  width: 494px;
}

.community-list .SF-BAY-AREA-LOS {
  height: 98px;
  left: 989px;
  object-fit: cover;
  position: absolute;
  top: 209px;
  width: 186px;
}

.community-list .in-california {
  height: 67px;
  left: 709px;
  object-fit: cover;
  position: absolute;
  top: 61px;
  width: 313px;
}

.community-list .upcoming-events {
  height: 67px;
  left: 108px;
  object-fit: cover;
  position: absolute;
  top: 66px;
  width: 370px;
}

.community-list .group {
  height: 42px;
  left: 114px;
  object-fit: cover;
  position: absolute;
  top: 225px;
  width: 199px;
}

.community-list .meet-people-learn {
  height: 47px;
  left: 108px;
  object-fit: cover;
  position: absolute;
  top: 144px;
  width: 633px;
}

.community-list .overlap {
  height: 668px;
  left: -30px;
  position: absolute;
  top: 3560px;
  width: 1315px;
}

.community-list .line {
  height: 1px;
  left: 73px;
  object-fit: cover;
  position: absolute;
  top: 145px;
  width: 177px;
}

.community-list .rectangle-2 {
  height: 588px;
  left: 30px;
  object-fit: cover;
  position: absolute;
  top: 80px;
  width: 1285px;
}

.community-list .abramoss {
  height: 494px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 741px;
}

.community-list .post-birth-body {
  height: 90px;
  left: 821px;
  object-fit: cover;
  position: absolute;
  top: 281px;
  width: 397px;
}

.community-list .so-many-mamas-have {
  height: 192px;
  left: 821px;
  object-fit: cover;
  position: absolute;
  top: 434px;
  width: 397px;
}

.community-list .with-natalie-garay {
  height: 33px;
  left: 821px;
  object-fit: cover;
  position: absolute;
  top: 371px;
  width: 378px;
}

.community-list .READ-MORE {
  height: 16px;
  left: 823px;
  object-fit: cover;
  position: absolute;
  top: 606px;
  width: 72px;
}

.community-list .FEATURE-STORY {
  height: 16px;
  left: 823px;
  object-fit: cover;
  position: absolute;
  top: 239px;
  width: 359px;
}

.community-list .group-2 {
  height: 200px;
  left: 101px;
  object-fit: cover;
  position: absolute;
  top: 4371px;
  width: 1098px;
}

.community-list .overlap-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: cover;
  height: 673px;
  left: 0;
  position: absolute;
  top: 126px;
  width: 1280px;
}

.community-list .rectangle-3 {
  height: 27px;
  left: 807px;
  object-fit: cover;
  position: absolute;
  top: 130px;
  width: 333px;
}

.community-list .welcome-mama-glad {
  height: 138px;
  left: 813px;
  object-fit: cover;
  position: absolute;
  top: 120px;
  width: 402px;
}

.community-list .line-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50% 50%;
  background-size: cover;
  height: 456px;
  left: 670px;
  position: absolute;
  top: 1662px;
  width: 640px;
}

.community-list .line-2 {
  height: 1px;
  left: 210px;
  object-fit: cover;
  position: absolute;
  top: 167px;
  width: 177px;
}

.community-list .teaser-text-about {
  height: 94px;
  left: 117px;
  object-fit: cover;
  position: absolute;
  top: 1855px;
  width: 487px;
}

.community-list .stock-photo-female {
  height: 510px;
  left: 10px;
  object-fit: cover;
  position: absolute;
  top: 2230px;
  width: 640px;
}

.community-list .date-time-how-to {
  height: 24px;
  left: 742px;
  object-fit: cover;
  position: absolute;
  top: 2428px;
  width: 487px;
}

.community-list .MOVING-TOGETHER {
  height: 67px;
  left: 117px;
  object-fit: cover;
  position: absolute;
  top: 1741px;
  width: 269px;
}

.community-list .LIVE-ONLINE-EVENT {
  height: 67px;
  left: 742px;
  object-fit: cover;
  position: absolute;
  top: 2323px;
  width: 287px;
}

.community-list .WHITE-BUTTON {
  height: 42px;
  left: 116px;
  object-fit: cover;
  position: absolute;
  top: 1983px;
  width: 143px;
}

.community-list .WHITE-BUTTON-2 {
  height: 42px;
  left: 742px;
  object-fit: cover;
  position: absolute;
  top: 2528px;
  width: 151px;
}

.community-list .BAY-AREA-experiences {
  height: 26px;
  left: 116px;
  object-fit: cover;
  position: absolute;
  top: 1698px;
  width: 313px;
}

.community-list .upcoming-event {
  height: 26px;
  left: 742px;
  object-fit: cover;
  position: absolute;
  top: 2297px;
  width: 313px;
}

.community-list .overlap-3 {
  height: 480px;
  left: 0;
  position: absolute;
  top: 2999px;
  width: 428px;
}

.community-list .screenshot {
  height: 441px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 428px;
}

.community-list .rectangle-4 {
  height: 106px;
  left: 60px;
  object-fit: cover;
  position: absolute;
  top: 374px;
  width: 329px;
}

.community-list .GLOW-SALON {
  height: 32px;
  left: 167px;
  object-fit: cover;
  position: absolute;
  top: 407px;
  width: 116px;
}

.community-list .special-occasion {
  height: 16px;
  left: 132px;
  object-fit: cover;
  position: absolute;
  top: 441px;
  width: 186px;
}

.community-list .SACRAMENTO {
  height: 16px;
  left: 182px;
  object-fit: cover;
  position: absolute;
  top: 387px;
  width: 85px;
}

.community-list .overlap-4 {
  height: 480px;
  left: 430px;
  position: absolute;
  top: 2999px;
  width: 428px;
}

.community-list .rectangle-5 {
  height: 106px;
  left: 54px;
  object-fit: cover;
  position: absolute;
  top: 374px;
  width: 329px;
}

.community-list .SEASONS-LIFE {
  height: 32px;
  left: 107px;
  object-fit: cover;
  position: absolute;
  top: 404px;
  width: 222px;
}

.community-list .coaching-for-women {
  height: 16px;
  left: 89px;
  object-fit: cover;
  position: absolute;
  top: 440px;
  width: 258px;
}

.community-list .SANTA-MONICA {
  height: 16px;
  left: 173px;
  object-fit: cover;
  position: absolute;
  top: 387px;
  width: 93px;
}

.community-list .overlap-5 {
  height: 480px;
  left: 862px;
  position: absolute;
  top: 2999px;
  width: 428px;
}

.community-list .rectangle-6 {
  height: 106px;
  left: 49px;
  object-fit: cover;
  position: absolute;
  top: 374px;
  width: 329px;
}

.community-list .TINY-TOES {
  height: 32px;
  left: 170px;
  object-fit: cover;
  position: absolute;
  top: 404px;
  width: 90px;
}

.community-list .outdoor-preschool {
  height: 16px;
  left: 140px;
  object-fit: cover;
  position: absolute;
  top: 440px;
  width: 150px;
}

.community-list .line-3 {
  height: 1px;
  left: 80px;
  object-fit: cover;
  position: absolute;
  top: 160px;
  width: 177px;
}

.community-list .MARIN {
  height: 16px;
  left: 194px;
  object-fit: cover;
  position: absolute;
  top: 387px;
  width: 42px;
}

.community-list .overlap-6 {
  height: 156px;
  left: 258px;
  position: absolute;
  top: 2837px;
  width: 786px;
}

.community-list .things-we-love {
  height: 69px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 57px;
  width: 786px;
}

.community-list .group-3 {
  height: 156px;
  left: 45px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 156px;
}

.community-list .group-4 {
  height: 69px;
  left: 31px;
  object-fit: cover;
  position: absolute;
  top: 24px;
  width: 1206px;
}

.community-list .your-online {
  height: 69px;
  left: 247px;
  object-fit: cover;
  position: absolute;
  top: 878px;
  width: 786px;
}

.community-list .overlap-7 {
  height: 40px;
  left: 584px;
  position: absolute;
  top: 1016px;
  width: 170px;
}

.community-list .open-the-list {
  height: 25px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 5px;
  width: 141px;
}

.community-list .polygon {
  height: 40px;
  left: 137px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 34px;
}

.community-list .line-4 {
  height: 1px;
  left: 456px;
  object-fit: cover;
  position: absolute;
  top: 1829px;
  width: 177px;
}

.community-list .line-5 {
  height: 1px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 1839px;
  width: 177px;
}

.community-list .join-a-topic-group {
  height: 47px;
  left: 324px;
  object-fit: cover;
  position: absolute;
  top: 954px;
  width: 633px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CommunityPage/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yDAAsH;EACtH,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd","sourcesContent":[".community-list {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n}\n\n.community-list .div {\n  background-color: #ffffff;\n  height: 4619px;\n  overflow: hidden;\n  position: relative;\n  width: 1280px;\n}\n\n.community-list .overlap-group {\n  height: 370px;\n  left: -1px;\n  position: absolute;\n  top: 1146px;\n  width: 1281px;\n}\n\n.community-list .rectangle {\n  height: 369px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 634px;\n}\n\n.community-list .img {\n  height: 369px;\n  left: 634px;\n  mix-blend-mode: multiply;\n  object-fit: cover;\n  position: absolute;\n  top: 1px;\n  width: 647px;\n}\n\n.community-list .connect-with-your {\n  height: 47px;\n  left: 710px;\n  object-fit: cover;\n  position: absolute;\n  top: 145px;\n  width: 494px;\n}\n\n.community-list .SF-BAY-AREA-LOS {\n  height: 98px;\n  left: 989px;\n  object-fit: cover;\n  position: absolute;\n  top: 209px;\n  width: 186px;\n}\n\n.community-list .in-california {\n  height: 67px;\n  left: 709px;\n  object-fit: cover;\n  position: absolute;\n  top: 61px;\n  width: 313px;\n}\n\n.community-list .upcoming-events {\n  height: 67px;\n  left: 108px;\n  object-fit: cover;\n  position: absolute;\n  top: 66px;\n  width: 370px;\n}\n\n.community-list .group {\n  height: 42px;\n  left: 114px;\n  object-fit: cover;\n  position: absolute;\n  top: 225px;\n  width: 199px;\n}\n\n.community-list .meet-people-learn {\n  height: 47px;\n  left: 108px;\n  object-fit: cover;\n  position: absolute;\n  top: 144px;\n  width: 633px;\n}\n\n.community-list .overlap {\n  height: 668px;\n  left: -30px;\n  position: absolute;\n  top: 3560px;\n  width: 1315px;\n}\n\n.community-list .line {\n  height: 1px;\n  left: 73px;\n  object-fit: cover;\n  position: absolute;\n  top: 145px;\n  width: 177px;\n}\n\n.community-list .rectangle-2 {\n  height: 588px;\n  left: 30px;\n  object-fit: cover;\n  position: absolute;\n  top: 80px;\n  width: 1285px;\n}\n\n.community-list .abramoss {\n  height: 494px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 741px;\n}\n\n.community-list .post-birth-body {\n  height: 90px;\n  left: 821px;\n  object-fit: cover;\n  position: absolute;\n  top: 281px;\n  width: 397px;\n}\n\n.community-list .so-many-mamas-have {\n  height: 192px;\n  left: 821px;\n  object-fit: cover;\n  position: absolute;\n  top: 434px;\n  width: 397px;\n}\n\n.community-list .with-natalie-garay {\n  height: 33px;\n  left: 821px;\n  object-fit: cover;\n  position: absolute;\n  top: 371px;\n  width: 378px;\n}\n\n.community-list .READ-MORE {\n  height: 16px;\n  left: 823px;\n  object-fit: cover;\n  position: absolute;\n  top: 606px;\n  width: 72px;\n}\n\n.community-list .FEATURE-STORY {\n  height: 16px;\n  left: 823px;\n  object-fit: cover;\n  position: absolute;\n  top: 239px;\n  width: 359px;\n}\n\n.community-list .group-2 {\n  height: 200px;\n  left: 101px;\n  object-fit: cover;\n  position: absolute;\n  top: 4371px;\n  width: 1098px;\n}\n\n.community-list .overlap-2 {\n  background-image: url(../../../public/static/img/spence-10.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 673px;\n  left: 0;\n  position: absolute;\n  top: 126px;\n  width: 1280px;\n}\n\n.community-list .rectangle-3 {\n  height: 27px;\n  left: 807px;\n  object-fit: cover;\n  position: absolute;\n  top: 130px;\n  width: 333px;\n}\n\n.community-list .welcome-mama-glad {\n  height: 138px;\n  left: 813px;\n  object-fit: cover;\n  position: absolute;\n  top: 120px;\n  width: 402px;\n}\n\n.community-list .line-wrapper {\n  background-image: url(../../../public/static/img/stock-photo-rear-view-of-female-friends-practicing-vrikshasana-o.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 456px;\n  left: 670px;\n  position: absolute;\n  top: 1662px;\n  width: 640px;\n}\n\n.community-list .line-2 {\n  height: 1px;\n  left: 210px;\n  object-fit: cover;\n  position: absolute;\n  top: 167px;\n  width: 177px;\n}\n\n.community-list .teaser-text-about {\n  height: 94px;\n  left: 117px;\n  object-fit: cover;\n  position: absolute;\n  top: 1855px;\n  width: 487px;\n}\n\n.community-list .stock-photo-female {\n  height: 510px;\n  left: 10px;\n  object-fit: cover;\n  position: absolute;\n  top: 2230px;\n  width: 640px;\n}\n\n.community-list .date-time-how-to {\n  height: 24px;\n  left: 742px;\n  object-fit: cover;\n  position: absolute;\n  top: 2428px;\n  width: 487px;\n}\n\n.community-list .MOVING-TOGETHER {\n  height: 67px;\n  left: 117px;\n  object-fit: cover;\n  position: absolute;\n  top: 1741px;\n  width: 269px;\n}\n\n.community-list .LIVE-ONLINE-EVENT {\n  height: 67px;\n  left: 742px;\n  object-fit: cover;\n  position: absolute;\n  top: 2323px;\n  width: 287px;\n}\n\n.community-list .WHITE-BUTTON {\n  height: 42px;\n  left: 116px;\n  object-fit: cover;\n  position: absolute;\n  top: 1983px;\n  width: 143px;\n}\n\n.community-list .WHITE-BUTTON-2 {\n  height: 42px;\n  left: 742px;\n  object-fit: cover;\n  position: absolute;\n  top: 2528px;\n  width: 151px;\n}\n\n.community-list .BAY-AREA-experiences {\n  height: 26px;\n  left: 116px;\n  object-fit: cover;\n  position: absolute;\n  top: 1698px;\n  width: 313px;\n}\n\n.community-list .upcoming-event {\n  height: 26px;\n  left: 742px;\n  object-fit: cover;\n  position: absolute;\n  top: 2297px;\n  width: 313px;\n}\n\n.community-list .overlap-3 {\n  height: 480px;\n  left: 0;\n  position: absolute;\n  top: 2999px;\n  width: 428px;\n}\n\n.community-list .screenshot {\n  height: 441px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 428px;\n}\n\n.community-list .rectangle-4 {\n  height: 106px;\n  left: 60px;\n  object-fit: cover;\n  position: absolute;\n  top: 374px;\n  width: 329px;\n}\n\n.community-list .GLOW-SALON {\n  height: 32px;\n  left: 167px;\n  object-fit: cover;\n  position: absolute;\n  top: 407px;\n  width: 116px;\n}\n\n.community-list .special-occasion {\n  height: 16px;\n  left: 132px;\n  object-fit: cover;\n  position: absolute;\n  top: 441px;\n  width: 186px;\n}\n\n.community-list .SACRAMENTO {\n  height: 16px;\n  left: 182px;\n  object-fit: cover;\n  position: absolute;\n  top: 387px;\n  width: 85px;\n}\n\n.community-list .overlap-4 {\n  height: 480px;\n  left: 430px;\n  position: absolute;\n  top: 2999px;\n  width: 428px;\n}\n\n.community-list .rectangle-5 {\n  height: 106px;\n  left: 54px;\n  object-fit: cover;\n  position: absolute;\n  top: 374px;\n  width: 329px;\n}\n\n.community-list .SEASONS-LIFE {\n  height: 32px;\n  left: 107px;\n  object-fit: cover;\n  position: absolute;\n  top: 404px;\n  width: 222px;\n}\n\n.community-list .coaching-for-women {\n  height: 16px;\n  left: 89px;\n  object-fit: cover;\n  position: absolute;\n  top: 440px;\n  width: 258px;\n}\n\n.community-list .SANTA-MONICA {\n  height: 16px;\n  left: 173px;\n  object-fit: cover;\n  position: absolute;\n  top: 387px;\n  width: 93px;\n}\n\n.community-list .overlap-5 {\n  height: 480px;\n  left: 862px;\n  position: absolute;\n  top: 2999px;\n  width: 428px;\n}\n\n.community-list .rectangle-6 {\n  height: 106px;\n  left: 49px;\n  object-fit: cover;\n  position: absolute;\n  top: 374px;\n  width: 329px;\n}\n\n.community-list .TINY-TOES {\n  height: 32px;\n  left: 170px;\n  object-fit: cover;\n  position: absolute;\n  top: 404px;\n  width: 90px;\n}\n\n.community-list .outdoor-preschool {\n  height: 16px;\n  left: 140px;\n  object-fit: cover;\n  position: absolute;\n  top: 440px;\n  width: 150px;\n}\n\n.community-list .line-3 {\n  height: 1px;\n  left: 80px;\n  object-fit: cover;\n  position: absolute;\n  top: 160px;\n  width: 177px;\n}\n\n.community-list .MARIN {\n  height: 16px;\n  left: 194px;\n  object-fit: cover;\n  position: absolute;\n  top: 387px;\n  width: 42px;\n}\n\n.community-list .overlap-6 {\n  height: 156px;\n  left: 258px;\n  position: absolute;\n  top: 2837px;\n  width: 786px;\n}\n\n.community-list .things-we-love {\n  height: 69px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 57px;\n  width: 786px;\n}\n\n.community-list .group-3 {\n  height: 156px;\n  left: 45px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 156px;\n}\n\n.community-list .group-4 {\n  height: 69px;\n  left: 31px;\n  object-fit: cover;\n  position: absolute;\n  top: 24px;\n  width: 1206px;\n}\n\n.community-list .your-online {\n  height: 69px;\n  left: 247px;\n  object-fit: cover;\n  position: absolute;\n  top: 878px;\n  width: 786px;\n}\n\n.community-list .overlap-7 {\n  height: 40px;\n  left: 584px;\n  position: absolute;\n  top: 1016px;\n  width: 170px;\n}\n\n.community-list .open-the-list {\n  height: 25px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 5px;\n  width: 141px;\n}\n\n.community-list .polygon {\n  height: 40px;\n  left: 137px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 34px;\n}\n\n.community-list .line-4 {\n  height: 1px;\n  left: 456px;\n  object-fit: cover;\n  position: absolute;\n  top: 1829px;\n  width: 177px;\n}\n\n.community-list .line-5 {\n  height: 1px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 1839px;\n  width: 177px;\n}\n\n.community-list .join-a-topic-group {\n  height: 47px;\n  left: 324px;\n  object-fit: cover;\n  position: absolute;\n  top: 954px;\n  width: 633px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
